function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Object, String, editingPropertyType, propertyFilter, searchFilter) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['filter-operator-dropdown'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-select", {
          "attrs": __vjadeStringifyAttrsIfObj({
            options: JSON.stringify($helpers.getFilterOperators()),
            'selected-option': propertyFilter.filterOperator,
          }),
          "on": {
            change: e => $helpers.changeFilterOperator(e.detail.value),
          },
          "class": {
            'pvs-filter-operator-dropdown': true
          },
        }));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['filter-number-input'] = function({
      value = ``,
      onInput = null,
      autofocus = false,
      key = null
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-input", {
          "attrs": __vjadeStringifyAttrsIfObj({
            type: `number`,
          }),
          "props": {
            value,
          },
          "on": {
            input: onInput,
          },
          "hook": {
            insert: autofocus ? $helpers.focusInput : null,
          },
          "key": key,
          "class": {
            'pvs-filter-numdate-input': true
          },
        }));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['filter-string-input'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-input", {
          "attrs": __vjadeStringifyAttrsIfObj({
            elref: `filterValueInput`,
            'select-on-focus': true,
            type: `text`,
            icon: `search`,
            placeholder: `Search`,
          }),
          "props": {
            value: propertyFilter.filterValue,
          },
          "on": {
            input: e => $helpers.changeFilterValue(e.target.value),
          },
          "key": `string-${propertyFilter.filterOperator}`,
          "hook": {
            insert: $helpers.focusInput,
          },
          "class": {
            'pvs-filter-string-input': true
          },
        }));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "hook": {
          postpatch: $helpers.dispatchDraw
        },
        "class": Object.assign({}, {
          'pvs-display-context-custom-event': $helpers.getDisplayContext() === $helpers.PropertyFilterDisplayContext.CustomEvent,
        }, {
          'pvs-container': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((!$attr(`display-value-only`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'pvs-title-section': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(($helpers.hasBackButton()) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "on": {
                  click: $helpers.clickBackButton,
                },
                "class": {
                  'pvs-back-button': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    icon: `caret-left`
                  }),
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'pvs-property-type-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "on": {
                  click: $helpers.clickPropertyTypeButton,
                },
                "class": Object.assign({}, {
                  'pvs-property-type-button-enabled': $helpers.canTypeCast()
                }, {
                  'pvs-property-type-button': true
                }),
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    icon: $helpers.getPropertyTypeIcon()
                  }),
                }));
                const propertyLabel = $helpers.getPropertyLabel();
                __jade_nodes = __jade_nodes.concat(h("span", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    title: propertyLabel,
                  }),
                  "class": {
                    'pvs-property-type-label': true
                  },
                }, [__vjadeSafeCode($helpers.truncateMiddle(propertyLabel, 30))]));
                __jade_nodes = __jade_nodes.concat(($helpers.canTypeCast()) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      icon: `filled-caret-down`
                    }),
                  }));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(($helpers.canTypeCast()) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'pvs-property-types-menu': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      open: editingPropertyType
                    }),
                    "on": {
                      change: $helpers.changePropertyTypesMenu,
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        sections: JSON.stringify($helpers.getPropertyTypeMenuSections()),
                      }),
                      "on": {
                        clickItem: $helpers.clickPropertyTypesMenuItem,
                      },
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'pvs-filter-section': true
          },
        }, (function() {
          var __jade_nodes = [];
          const {
            propertyType,
            propertyObjectKey
          } = propertyFilter;;
          __jade_nodes = __jade_nodes.concat(($helpers.enhancedListFilterEnabled()) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'pvs-list-options': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'pvs-option-label': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Match");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("mp-select", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  sections: JSON.stringify($helpers.getListQuantifierSections()),
                }),
                "on": {
                  change: $helpers.handleListQuantifierSelect,
                },
                "class": {
                  'pvs-filter-list-quantifier': true
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((((propertyType) == ($helpers.PropertyType.Object))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(($helpers.isLoadingPropertyValues()) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'pvs-filter-property-values-loading': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-spinner"));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'pvs-filter-fixed-subsection': true,
                    'pvs-filter-for-object': true,
                    'pvs-first-subsection': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'pvs-filter-label': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("Where");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("mp-select", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      'selected-option': propertyObjectKey === null ? `Choose a key` : ``,
                      'sections': JSON.stringify($helpers.getPropertyValueSections()),
                      'tabindex': 0,
                    }),
                    "on": {
                      'change': $helpers.selectObjectPropertyKey
                    },
                  }));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'pvs-filter-fixed-subsection': true,
                    'pvs-filter-for-object': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'pvs-filter-label': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("Equals");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("mp-select", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      'disabled': propertyObjectKey === null,
                      'selected-option': propertyObjectKey === null ? `Select a key first` : ``,
                      'sections': JSON.stringify($helpers.getObjectPropertyValueSections()),
                      'tabindex': 0,
                    }),
                    "on": {
                      'change': $helpers.selectObjectPropertyValue
                    },
                    "props": {
                      sectionsFromInputFn: $helpers.sectionsFromInputFn
                    },
                  }));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)));;
              return __jade_nodes
            }).call(this)) :
            (((propertyType) == ($helpers.PropertyType.Number))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((!$attr(`display-value-only`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'pvs-filter-fixed-subsection': true,
                    'pvs-first-subsection': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(jade_mixins['filter-operator-dropdown'].call(this));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": Object.assign({}, {
                  'pvs-filter-numdate-between': propertyFilter.filterOperator === $helpers.NumberOperator.Between,
                }, {
                  'pvs-filter-fixed-subsection': true
                }),
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((((propertyFilter.filterOperator) == ($helpers.NumberOperator.Between)) || ((propertyFilter.filterOperator) == ($helpers.NumberOperator.NotBetween))) ?
                  ((function() {
                    var __jade_nodes = [];
                    const [minNum, maxNum] = propertyFilter.filterValue;
                    __jade_nodes = __jade_nodes.concat(jade_mixins['filter-number-input'].call(this, {
                      value: minNum,
                      onInput: ev => $helpers.changeFilterValue(
                        [$helpers.parseNumber(ev.target.value), maxNum]
                      ),
                      autofocus: true,
                      key: `num-min`,
                    }));
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'pvs-filter-conjunction': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("and");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat(jade_mixins['filter-number-input'].call(this, {
                      value: maxNum,
                      onInput: ev => $helpers.changeFilterValue(
                        [minNum, $helpers.parseNumber(ev.target.value)]
                      ),
                      autofocus: false,
                      key: `num-max`,
                    }));;
                    return __jade_nodes
                  }).call(this)) :
                  ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(jade_mixins['filter-number-input'].call(this, {
                      value: propertyFilter.filterValue,
                      onInput: e => $helpers.changeFilterValue($helpers.parseNumber(e.target.value)),
                      autofocus: true,
                      key: `num-val-${propertyFilter.filterOperator}`,
                    }));;
                    return __jade_nodes
                  }).call(this)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) :
            (((propertyType) == ($helpers.PropertyType.Boolean)) || ((propertyType) == ($helpers.PropertyType.List))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((!$attr(`display-value-only`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'pvs-filter-fixed-subsection': true,
                    'pvs-filter-radio-list': true,
                    'pvs-first-subsection': true
                  },
                }, (function() {
                  var __jade_nodes = []; /*  TODO(mack): For the custom events property filter, we only support 'contains' operator. */
                  /*  Use a different UI rather than a single radio button in this case? */
                  __jade_nodes = __jade_nodes.concat((function() {
                    var $$obj = ($helpers.getFilterOperators());
                    var $$eachNodes;
                    var $$iterated = false;
                    if (Array.isArray($$obj)) {
                      $$eachNodes = $$obj.reduce(function($$eachNodes, filterOperator, $index) {
                        $$iterated = true;
                        return $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'pvs-radio-button-container': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-radio-button", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                selected: filterOperator === propertyFilter.filterOperator,
                              }),
                              "on": {
                                click: () => $helpers.changeFilterOperator(filterOperator),
                              },
                            }, [__vjadeSafeCode(filterOperator)]));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this));
                      }, []);
                    } else {
                      $$eachNodes = [];
                      for (var $$objKey in $$obj) {
                        (function() {
                          var $index = $$objKey;
                          if ($$obj.hasOwnProperty($index)) {
                            $$iterated = true;
                            var filterOperator = $$obj[$index];
                            $$eachNodes = $$eachNodes.concat((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'pvs-radio-button-container': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("mp-radio-button", {
                                  "attrs": __vjadeStringifyAttrsIfObj({
                                    selected: filterOperator === propertyFilter.filterOperator,
                                  }),
                                  "on": {
                                    click: () => $helpers.changeFilterOperator(filterOperator),
                                  },
                                }, [__vjadeSafeCode(filterOperator)]));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this));
                          }
                        })();
                      }
                    }

                    return $$eachNodes;
                  })());;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat((propertyType === $helpers.PropertyType.List) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'pvs-filter-fixed-subsection': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(($helpers.isCampaignMessagesPropertyFilter()) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-select", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        'menu-height': 180,
                        'selected-option': propertyFilter.filterValue ? $helpers.renamePropertyValue(propertyFilter.filterValue) : `Select an option`,
                        'sections': $helpers.getMessagesSentSections(),
                      }),
                      "on": {
                        'change': ev => $helpers.changeFilterValue(ev.detail.item.value),
                      },
                    }));;
                    return __jade_nodes
                  }).call(this)) : ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(jade_mixins['filter-string-input'].call(this));;
                    return __jade_nodes
                  }).call(this)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this)) :
            (((propertyType) == ($helpers.PropertyType.String))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((!$attr(`display-value-only`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'pvs-filter-fixed-subsection': true,
                    'pvs-first-subsection': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(jade_mixins['filter-operator-dropdown'].call(this));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat((((propertyFilter.filterOperator) == ($helpers.StringOperator.Contains)) || ((propertyFilter.filterOperator) == ($helpers.StringOperator.DoesNotContain))) ?
                ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'pvs-filter-fixed-subsection': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(jade_mixins['filter-string-input'].call(this));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(($helpers.isLoadingPropertyValues()) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'pvs-filter-property-values-loading': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-spinner"));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'pvs-filter-property-values': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
                        "attrs": __vjadeStringifyAttrsIfObj($helpers.filterAttributes({
                          'search-exact': true,
                          'search-filter': propertyFilter.filterValue ? $helpers.renamePropertyValue(propertyFilter.filterValue) : null,
                          sections: JSON.stringify($helpers.getPropertyValueSections()),
                        })),
                        "on": {
                          clickItem: e => $helpers.selectContainsPropertyValue(e.detail.item.propertyValue),
                          draw: $helpers.propagateEvent,
                        },
                        "props": {
                          keydownProxyEl: $helpers.getKeydownProxyEl()
                        },
                        "class": {
                          'pvs-property-value-list': true
                        },
                      }));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)));;
                  return __jade_nodes
                }).call(this)) :
                (((propertyFilter.filterOperator) == ($helpers.StringOperator.Equals)) || ((propertyFilter.filterOperator) == ($helpers.StringOperator.DoesNotEqual))) ?
                ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'pvs-filter-fixed-subsection': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-input", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        elref: `filterValueInput`,
                        icon: `search`,
                        placeholder: `Search`,
                      }),
                      "props": {
                        value: searchFilter
                      },
                      "key": `string-${propertyFilter.filterOperator}`,
                      "hook": {
                        insert: $helpers.insertedIconInput
                      },
                      "on": {
                        input: e => $helpers.changeSearchFilter(e.target.value)
                      },
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(($helpers.isLoadingPropertyValues() && !searchFilter) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'pvs-filter-property-values-loading': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-spinner"));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'pvs-filter-property-values': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
                        "attrs": __vjadeStringifyAttrsIfObj($helpers.filterAttributes({
                          'search-filter': searchFilter,
                          'show-csv-matches': true,
                          'show-select-all': true,
                          'show-select-all-matching': true,
                          multiple: true,
                          elref: `string-property-select-menu`,
                        })),
                        "on": {
                          selectAllMatching: $helpers.selectAllMatching,
                          selectAll: $helpers.selectAllPropertyValues,
                          clickItem: e => $helpers.toggleFilterItem(e.detail.item),
                          draw: $helpers.propagateEvent,
                        },
                        "props": {
                          sectionsFromInputFn: $helpers.sectionsFromInputFn,
                          sections: $helpers.getPropertyValueSections(),
                          keydownProxyEl: $helpers.getKeydownProxyEl()
                        },
                      }));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)));;
                  return __jade_nodes
                }).call(this)) :
                undefined);;
              return __jade_nodes
            }).call(this)) :
            (((propertyType) == ($helpers.PropertyType.Datetime))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-date-range-picker", {
                "attrs": __vjadeStringifyAttrsIfObj($helpers.filterAttributes({
                  'display-context': $helpers.getDateRangePickerDisplayContext(),
                  'date-range': JSON.stringify(propertyFilter.filterValue),
                })),
                "on": {
                  changeDateRange: $helpers.changeDateRange,
                  draw: $helpers.propagateEvent,
                },
              }));;
              return __jade_nodes
            }).call(this)) :
            undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("mp-button-bar", {
          "attrs": __vjadeStringifyAttrsIfObj({
            disabled: !propertyFilter.isValid(),
            tabindex: 0,
          }),
          "on": {
            click: $helpers.clickAddFilter,
          },
          "class": {
            'mp-button-bar-primary': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat("Add Filter");;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "editingPropertyType" in locals ? locals.editingPropertyType : typeof editingPropertyType !== "undefined" ? editingPropertyType : undefined, "propertyFilter" in locals ? locals.propertyFilter : typeof propertyFilter !== "undefined" ? propertyFilter : undefined, "searchFilter" in locals ? locals.searchFilter : typeof searchFilter !== "undefined" ? searchFilter : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;